import store from "@/state/store";

function redirectIfLoggedIn(routeTo, routeFrom, next) {
  if (store.getters["auth/loggedIn"]) {
    next({ name: "default" });
  } else {
    next();
  }
}

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Σύνδεση",
      beforeResolve: redirectIfLoggedIn,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Εγγραφή",
      beforeResolve: redirectIfLoggedIn,
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Ανάκτηση Κωδικού",
      beforeResolve: redirectIfLoggedIn,
    },
  },

  // Real app routes (Step 2 routing skeleton — pages are placeholders,
  // built out in a later step). Mirrors root's menu.js / admin-menu.js split.
  {
    path: "/",
    name: "default",
    meta: { title: "Ταμείο", authRequired: true },
    component: () => import("../views/app/dashboard.vue"),
  },
  {
    path: "/users/customers/list",
    name: "Customer List",
    meta: { title: "Πελατολόγιο", authRequired: true },
    component: () => import("../views/app/customers.vue"),
  },
  {
    path: "/users/customers/new",
    name: "New Customer",
    meta: { title: "Νέος Πελάτης", authRequired: true },
    component: () => import("../views/app/new-customer.vue"),
  },
  {
    path: "/users/profile/:userId",
    name: "Customer Profile",
    meta: { title: "Προφίλ Πελάτη", authRequired: true },
    component: () => import("../views/app/customer-profile.vue"),
  },
  {
    path: "/users/:userId/history",
    name: "Customer History",
    meta: { title: "Ιστορικό Πελάτη", authRequired: true },
    component: () => import("../views/app/customer-history.vue"),
  },
  {
    path: "/users/team/list",
    name: "Team List",
    meta: { title: "Προσωπικό", authRequired: true },
    component: () => import("../views/app/team.vue"),
  },
  {
    path: "/users/team-member/new",
    name: "New Team Member",
    meta: { title: "Νέο Μέλος Προσωπικού", authRequired: true },
    component: () => import("../views/app/new-team-member.vue"),
  },
  {
    path: "/appointments/list",
    name: "Appointments List",
    meta: { title: "Ραντεβού", authRequired: true },
    component: () => import("../views/app/appointments.vue"),
  },
  {
    path: "/appointments/new",
    name: "New Appointment",
    meta: { title: "Νέο Ραντεβού", authRequired: true },
    component: () => import("../views/app/new-appointment.vue"),
  },
  {
    path: "/appointments/edit/:appointmentId",
    name: "Edit Appointment",
    meta: { title: "Επεξεργασία Ραντεβού", authRequired: true },
    component: () => import("../views/app/edit-appointment.vue"),
  },
  {
    path: "/expenses/list",
    name: "Expenses List",
    meta: { title: "Έξοδα", authRequired: true },
    component: () => import("../views/app/expenses.vue"),
  },
  {
    path: "/expenses/new",
    name: "New Expense",
    meta: { title: "Νέα Έξοδα", authRequired: true },
    component: () => import("../views/app/new-expense.vue"),
  },
  {
    path: "/expenses/edit/:expenseId",
    name: "Edit Expense",
    meta: { title: "Τροποποίηση Εξόδων", authRequired: true },
    component: () => import("../views/app/edit-expense.vue"),
  },
  {
    path: "/products/list",
    name: "Products List",
    meta: { title: "Προιόντα", authRequired: true },
    component: () => import("../views/app/products.vue"),
  },
  {
    path: "/products/new",
    name: "New Product",
    meta: { title: "Νέο Προιόν", authRequired: true },
    component: () => import("../views/app/new-product.vue"),
  },
  {
    path: "/products/edit/:productId",
    name: "Edit Product",
    meta: { title: "Τροποποίηση Προιόντος", authRequired: true },
    component: () => import("../views/app/edit-product.vue"),
  },
  {
    path: "/sales/list",
    name: "Sales List",
    meta: { title: "Πωλήσεις", authRequired: true },
    component: () => import("../views/app/sales.vue"),
  },
  {
    path: "/sales/new",
    name: "New Sale",
    meta: { title: "Νέα Πώληση", authRequired: true },
    component: () => import("../views/app/new-sale.vue"),
  },
  {
    path: "/sales/edit/:saleId",
    name: "Edit Sale",
    meta: { title: "Τροποποίηση Πώλησης", authRequired: true },
    component: () => import("../views/app/edit-sale.vue"),
  },
  {
    path: "/services/list",
    name: "Services List",
    meta: { title: "Υπηρεσίες", authRequired: true },
    component: () => import("../views/app/services.vue"),
  },
  {
    path: "/services/new",
    name: "New Service",
    meta: { title: "Νέα Υπηρεσία", authRequired: true },
    component: () => import("../views/app/new-service.vue"),
  },
  {
    path: "/services/edit/:serviceId",
    name: "Edit Service",
    meta: { title: "Τροποποίηση Υπηρεσίας", authRequired: true },
    component: () => import("../views/app/edit-service.vue"),
  },
  {
    path: "/categories/list",
    name: "Categories List",
    meta: { title: "Κατηγορίες", authRequired: true },
    component: () => import("../views/app/categories.vue"),
  },
  {
    path: "/expense-categories/list",
    name: "Expense Categories List",
    meta: { title: "Κατηγορίες Εξόδων", authRequired: true },
    component: () => import("../views/app/expense-categories.vue"),
  },
  {
    path: "/expense-categories/new",
    name: "New Expense Category",
    meta: { title: "Νέα Κατηγορία Εξόδων", authRequired: true },
    component: () => import("../views/app/new-expense-category.vue"),
  },
  {
    path: "/expense-categories/edit/:expenseCategoryId",
    name: "Edit Expense Category",
    meta: { title: "Τροποποίηση Κατηγορίας Εξόδων", authRequired: true },
    component: () => import("../views/app/edit-expense-category.vue"),
  },
  {
    path: "/product-categories/list",
    name: "Product Categories List",
    meta: { title: "Κατηγορίες Προιόντων", authRequired: true },
    component: () => import("../views/app/product-categories.vue"),
  },
  {
    path: "/product-categories/new",
    name: "New Product Category",
    meta: { title: "Νέα Κατηγορία Προιόντων", authRequired: true },
    component: () => import("../views/app/new-product-category.vue"),
  },
  {
    path: "/product-categories/edit/:productCategoryId",
    name: "Edit Product Category",
    meta: { title: "Τροποποίηση Κατηγορίας Προιόντων", authRequired: true },
    component: () => import("../views/app/edit-product-category.vue"),
  },
  // Admin-only
  {
    path: "/users/admins/list",
    name: "Admin List",
    meta: { title: "Διαχειριστές", authRequired: true, adminRequired: true },
    component: () => import("../views/app/admins.vue"),
  },
  {
    path: "/users/admins/new",
    name: "New Admin",
    meta: { title: "Νέος Διαχειριστής", authRequired: true, adminRequired: true },
    component: () => import("../views/app/new-admin.vue"),
  },
  {
    path: "/analytics/list",
    name: "Analytics",
    meta: { title: "Αναλυτικά Στοιχεία", authRequired: true, adminRequired: true },
    component: () => import("../views/app/analytics.vue"),
  },
  {
    path: "/reports/list",
    name: "Reports",
    meta: { title: "Αναφορές Δεδομένων", authRequired: true, adminRequired: true },
    component: () => import("../views/app/reports.vue"),
  },

  // Check-App — admin-only (role-gated both here via adminRequired and via
  // the admin sidebar menu, which only shows these links to role: 'admin').
  {
    path: "/check-app/categories",
    name: "Check-App Categories",
    meta: { title: "Κατηγορίες & Αντικείμενα Check-App", authRequired: true, adminRequired: true },
    component: () => import("../views/app/check-app-categories.vue"),
  },
  {
    path: "/check-app/form",
    name: "Check-App Form",
    meta: { title: "Λίστα Ελέγχου Check-App", authRequired: true, adminRequired: true },
    component: () => import("../views/app/check-app-form.vue"),
  },
  {
    path: "/check-app/history",
    name: "Check-App History",
    meta: { title: "Ιστορικό Λιστών Ελέγχου", authRequired: true, adminRequired: true },
    component: () => import("../views/app/check-app-history.vue"),
  },

  // Owner Management — there's no separate "owner" role; Owner == Admin, so
  // this is admin-gated the same as every other admin screen.
  {
    path: "/owner/management",
    name: "Owner Management",
    meta: { title: "Κεντρική Διαχείριση", authRequired: true, adminRequired: true },
    component: () => import("../views/app/owner-management.vue"),
  },

  {
    path: "/404",
    name: "404",
    meta: { title: "Η Σελίδα Δεν Βρέθηκε" },
    component: () => import("../views/auth/errors/404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];
